import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";

export type SortField = "keyword" | "currentRank" | "rankChange" | "searchVolume" | "bestRank" | "dateAdded";
export type SortDirection = "asc" | "desc" | null;

export interface SortState {
  field: SortField | null;
  direction: SortDirection;
}

export function SortIcon({ field, sort }: { field: SortField; sort: SortState }) {
  if (sort.field !== field) return <ArrowUpDown className="h-3 w-3 opacity-40" />;
  if (sort.direction === "asc") return <ArrowUp className="h-3 w-3" />;
  return <ArrowDown className="h-3 w-3" />;
}
